import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('aircraftTable');

    return {
        ACTIONS_LABEL: t('actionsLabel'),
        DELETE: t('delete'),
        DELETE_ERROR: t('deleteError'),
        DELETE_SUCCESS: t('deleteSuccess'),
        EDIT: t('edit'),
        EMPTY_DESCRIPTION: t('emptyDescription'),
        EMPTY_HEADING: t('emptyHeading'),
        FLIGHT_CONTROLLER_SERIAL: t('flightControllerSerial'),
        LOAD_ERROR: t('loadError'),
        LOAD_MORE: t('loadMore'),
        MAKE: t('make'),
        MODEL: t('model'),
        NAME: t('name'),
        REGISTRATION_NUMBER: t('registrationNumber'),
        SERIAL_NUMBER: t('serialNumber'),
        SWATH_WIDTH: t('swathWidth'),
        TABLE_LABEL: t('tableLabel')
    };
};

export default useTranslation;
